{
  "title": "Settings",
  "landing": {
    "interface": "Interface settings",
    "interfaceDesc": "Language, theme and colour",
    "hotkeys": "Keyboard shortcuts",
    "hotkeysDesc": "Key combinations"
  },
  "actions": {
    "reset": "Restore defaults",
    "cancel": "Cancel",
    "save": "Save"
  },
  "saved": "Saved",
  "error": "Something went wrong",
  "resetTitle": "Restore the default settings?",
  "resetText": "Language, theme, accent colour and view return to their defaults. Click “Save” to keep them.",
  "resetConfirm": "Restore",
  "unsavedTitle": "Unsaved changes",
  "unsavedText": "Unsaved changes will be discarded.",
  "stay": "Stay",
  "leave": "Leave",
  "interface": {
    "title": "Interface settings",
    "language": "Language",
    "languageDesc": "Interface texts and date formats follow the selected language",
    "languages": {
      "uz-Latn": {
        "name": "O'zbekcha",
        "sub": "Lotin yozuvi"
      },
      "uz-Cyrl": {
        "name": "Ўзбекча",
        "sub": "Кирилл ёзуви"
      },
      "ru": {
        "name": "Русский",
        "sub": "Русский язык"
      },
      "en": {
        "name": "English",
        "sub": "English"
      }
    },
    "theme": "Theme",
    "themeDesc": "Light or dark mode. “System” follows the device setting",
    "themes": {
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    },
    "accent": "Accent colour",
    "accentDesc": "Used for buttons, the active tab and links",
    "customHex": "Custom colour (HEX)",
    "custom": "Custom colour",
    "accents": {
      "blue": "Blue",
      "green": "Green",
      "darkGreen": "Dark green",
      "yellow": "Yellow",
      "orange": "Orange",
      "red": "Red",
      "pink": "Pink",
      "purple": "Purple"
    },
    "view": "View",
    "compact": "Compact tables",
    "compactDesc": "Lower rows, more data on screen",
    "animations": "Animations",
    "animationsDesc": "Smooth transitions when panels and dialogs open",
    "fontSize": "Text size",
    "fontSizes": {
      "12": "Extra small (12 px)",
      "13": "Small (13 px)",
      "14": "Medium (14 px)",
      "15": "Large (15 px)",
      "16": "Extra large (16 px)"
    },
    "preview": "Preview",
    "previewDesc": "See how the selected theme and colour will look",
    "sample": {
      "title": "All employees",
      "add": "Add",
      "in": "Allowed",
      "out": "Denied",
      "viewOnly": "View only",
      "save": "Save",
      "cancel": "Cancel",
      "active": "Active employee"
    }
  },
  "hotkeys": {
    "title": "Keyboard shortcuts",
    "search": "Search by action or key",
    "conflicts": "{{count}} conflict(s)",
    "columns": {
      "action": "Action",
      "description": "Description",
      "combo": "Shortcut",
      "status": "Status",
      "actions": "Actions"
    },
    "groups": {
      "general": "General",
      "drawing": "Drawing",
      "table": "Table"
    },
    "status": {
      "default": "Default",
      "error": "Error",
      "modified": "Changed",
      "conflict": "Conflict",
      "editing": "Editing"
    },
    "capture": "Press keys...",
    "captureLabel": "New shortcut: {{name}}",
    "edit": "Edit",
    "accept": "Accept",
    "cancelEdit": "Cancel",
    "resetRow": "Restore default",
    "none": "Not set",
    "reserved": "This browser shortcut cannot be used",
    "busy": "Key in use: {{name}}",
    "saved": "Shortcut saved",
    "conflictToast": "This shortcut clashes with “{{name}}”",
    "resetAllTitle": "Restore all default shortcuts?",
    "resetAllText": "Every shortcut you changed returns to its default.",
    "resetConfirm": "Restore",
    "empty": "Nothing found",
    "emptyHint": "Try a different search.",
    "toggleGroup": "Expand or collapse “{{name}}”",
    "actions": {
      "create": {
        "label": "Create",
        "description": "Add a new item"
      },
      "save": {
        "label": "Save",
        "description": "Save changes"
      },
      "search": {
        "label": "Search",
        "description": "Open the global search"
      },
      "cancel": {
        "label": "Cancel",
        "description": "Close the window or cancel the action"
      },
      "refresh": {
        "label": "Refresh",
        "description": "Reload the data"
      },
      "help": {
        "label": "Help",
        "description": "Open the user guide"
      },
      "zoomIn": {
        "label": "Zoom in",
        "description": "Zoom into the drawing"
      },
      "zoomOut": {
        "label": "Zoom out",
        "description": "Zoom out of the drawing"
      },
      "addDevice": {
        "label": "Add device",
        "description": "Place a new device on the drawing"
      },
      "layers": {
        "label": "Layers",
        "description": "Show the layers menu"
      },
      "export": {
        "label": "Export",
        "description": "Download the table as Excel"
      },
      "copy": {
        "label": "Copy",
        "description": "Copy the selected rows"
      },
      "selectAll": {
        "label": "Select all",
        "description": "Select every row"
      },
      "saveChart": {
        "label": "Save chart",
        "description": "Save the current chart to a tab"
      }
    }
  }
}
